module.exports = {
      id: "qt-logo-usage",
      viewBox: "0 0 32 32",
      url: "/" + "sprite-bc5ff1507898764e0c54e53c34039c01.svg#qt-logo",
      toString: function () {
        return this.url;
      }
    }